const E = {
  First: 'First',
  Back: 'Back',
  Next: 'Next',
  Last: 'Last',
};

const F = {
  First: 'Premier',
  Back: 'Retour',
  Next: 'Suivant',
  Last: 'Dernier',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/pagination.js